module.exports = __webpack_public_path__ + "img/gb-con.b1ecbcc7.svg";